import React, { Component } from 'react';
import './Pagamento.css'
import ItensPedido from './../../components/itensPedido/ItensPedido'
import Header from './../../components/header/Header'
import { Redirect } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import services from './../../services/index';
import Loading from './../../components/loading/Loading';
import ConfirmaPedido from './../../components/confirmapedido/ConfirmaPedido';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons'
import BannerPromo from './../../components/bannerpromo/BannerPromo';
import validacoes from "../../libs/Validacoes"
import { FcClock } from "react-icons/fc"
import { MdClose } from "react-icons/md"

import TextField from '@material-ui/core/TextField';
import "react-datepicker/dist/react-datepicker.css";
import { Button } from '@material-ui/core';
import moment from "moment-timezone"
import { isArray } from "lodash"


import { BsFillHouseFill } from "react-icons/bs"

import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as Actions from "../../store/actions"

import { withRouter } from "react-router-dom";


import {
  CardType,
  ContainerTypes,
  LabelType,
  ContainerAgendamento,
  HeaderAgendamento
} from "./style"



import { mapKeys } from "lodash"



class Pagamento extends Component {


  constructor(props) {
    super(props);


    let loja = {};
    const aux = this.props.rdOrder.dados_loja ? this.props.rdOrder.dados_loja : undefined;

    if (aux) {
      if (isArray(aux)) {
        loja = aux[0];
      } else {
        loja = aux;
      }
    }


    this.state = {
      loja,
      arrItens: '',
      arrPags: [{ descricao: 'Dinheiro', solicita_troco: true }, { descricao: 'Visa Débito (levar Maquininha)', solicita_troco: false }
        , { descricao: 'Visa Crédito (levar Maquininha)', solicita_troco: false }, { descricao: 'Master Card (levar Maquininha)', solicita_troco: false }
      ],
      showPagamento: false,
      pagEscolhido: {},
      selectOption: 'nao',
      troco: '',
      loadingPage: false,
      confirmaPedido: false,
      numeroPedido: 0,
      obsPag: '',
      taxa: 0,
      total_pedido: this.props.rdOrder.total,
      topBanner: '-200000px',
      displayBanner: 'none',
      goEditarItens: false,
      cpfNaNota: "nao",
      cpf: "",
      horaRetirada: new Date(),
      typeDelivery: 0, // 1 entrega, 2 retirada, 3 agendada
      dtChoiced: new Date(),
      retiradaAgendada: false,
      entregaAgendada: false,
      showModalPagamentos: false,
      showAdressChoice: false
    }

  }

  async componentDidMount() {
    try {



      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      let currentStore = {};
      const auxStores = this.props.rdStores.stores;
      if (!isArray(auxStores)) {
        currentStore = this.props.rdStores.stores;
      } else {
        currentStore = this.props.rdStores.stores[0];
      }



      this.setState({ loadingPage: true });

      this.handlePromo();

      const loja = this.state.loja;

      const pagamentos = await services.getTiposPags(loja.id_loja);


      pagamentos.map(pag => {
        if (pag.solicita_troco === 'S') pag.solicita_troco = true
        else pag.solicita_troco = false;

        return pag;
      });



      const currentDate = moment().format('YYYY-MM-DDTHH:mm');


      this.setState({
        arrPags: pagamentos,
        loadingPage: false,
        horaRetirada: currentDate,
        retiradaAgendada: currentStore.retirada_agendada === 'S',
        entregaAgendada: currentStore.entrega_agendada === 'S'
      });
    } catch (error) {
      this.setState({ loadingPage: false });
      console.log(error);
    }


  }



  openModal = item => {

    if (this.state.typeDelivery === 1 && !this.props.rdOrder.adress.numero) {
      return this.setState({ showAdressChoice: true });
    }




    if (this.state.typeDelivery === 3 || this.state.typeDelivery === 4) {
      if (!this.validaAgendamentos()) return;

    }

    if (this.state.showModalPagamentos) {
      this.setState({ showModalPagamentos: false })
    }



    let descricao = item.descricao;

    if (!descricao) {


      this.setState({ showModalPagamentos: true });
      return;

      let dateAg = null;

      if (this.state.horaRetirada) {
        dateAg = moment(this.state.horaRetirada).format('DD/MM/YYYY HH:mm');
      }


      if (this.state.typeDelivery === 3) {
        //item.descricao = 'Entrega agendada para : ' + dateAg;
        this.setState({ showModalPagamentos: true });
        return;
      } else if (this.state.typeDelivery === 4) {
        item.descricao = 'Retirada agendada para : ' + dateAg;
      } else {
        item.descricao = 'Retirar na Loja';
      }


      this.setState({
        total_pedido: this.state.total_pedido - this.state.taxa,
        showPagamento: true,
        pagEscolhido: item,
        taxa: 0
      })
    } else {
      const response = services.totalizaItens(this.props.rdOrder.itens, this.state.taxa, '', true, false, this.state.taxa);
      this.setState({ showPagamento: true, pagEscolhido: item, total_pedido: response.data.total });
    }

  }

  closeModal = () => {

    this.setState({
      showPagamento: false,
      pagEscolhido: {},
      troco: '',
      selectOption: 'nao',
      obsPag: '',
      showModalPagamentos: false
    });
  }




  handleRadio = (e) => {
    this.setState({ selectOption: e.target.value, troco: '' });

  }

  handleTroco = (e) => {
    this.setState({ troco: e.target.value.replace(/[^0-9]/g, '') })
  }

  handleObsPag = (e) => {
    this.setState({ obsPag: e.target.value })
  }



  capitalizeKeys = (obj) => {
    const isObject = o => Object.prototype.toString.apply(o) === '[object Object]'
    const isArray = o => Object.prototype.toString.apply(o) === '[object Array]'

    let transformedObj = isArray(obj) ? [] : {}

    for (let key in obj) {
      // replace the following with any transform function
      const transformedKey = key.toLowerCase();

      if (isObject(obj[key]) || isArray(obj[key])) {
        transformedObj[transformedKey] = this.capitalizeKeys(obj[key])
      } else {
        transformedObj[transformedKey] = obj[key]
      }
    }
    return transformedObj
  }






  enviaPedido = async () => {
    //Esse é o metodo onde será criado o json e enviado.

    try {




      this.setState({ loadingPage: true });
      // if (!await this.props.rdOrder.funcVerificaLoja()) {
      // 	alert('A loja está fechada no momento');
      // 	this.tooggleLoading();
      // 	return
      // }

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      let troco = 0;



      this.setState({ numeroPedido: 0 });

      if (this.state.selectOption === 'sim' && !this.state.troco) {
        this.setState({ loadingPage: false });
        alert('Por favor, preencha o troco ou informe que não precisa de troca');
        return;
      } else if (this.state.selectOption === 'sim' && this.state.troco) {

        //valida troco. return em caso false, ou deixa o código continuar
        if (parseFloat(this.state.troco) <= parseFloat(this.state.total_pedido)) {
          this.setState({ loadingPage: false });
          alert('O troco não pode ser menor ou igual ao valor total da compra');
          return;
        } else {
          troco = this.state.troco;
        }
      }

      if (this.state.cpfNaNota === "sim") {

        if (!this.state.cpf) {
          this.setState({ loadingPage: false });
          alert("Por favor, preencha seu cpf/cnpj ou selecione a opção 'não' para o cpf/cnpj");
          return;
        }

        if (this.state.cpf.length === 11) {
          if (!validacoes.validaCPF(this.state.cpf)) {
            this.setState({ loadingPage: false });
            alert("CPF INVÁLIDO");
            return
          }
        } else if (this.state.cpf.length === 14) {
          if (!validacoes.validarCNPJ(this.state.cpf)) {
            this.setState({ loadingPage: false });
            alert("CNPJ INVÁLIDO");
            return
          }
        } else {
          this.setState({ loadingPage: false });
          alert("CPF / CNPJ INVÁLIDO");
          return
        }

      }



      let initItens = this.props.rdOrder.itens;

      initItens = this.capitalizeKeys(initItens);


      const { dados_cli: cli, enderecos, token } = services.getUser();

      //Pedro Melo - Correção da Selação do Endereço do Cliente.
      //const { adress } = this.props.rdUser;
      //const principal = adress.filter(a => a.principal === 1)[0];

      const principal = this.props.rdOrder.adress;
      let end = principal;

      let loja = this.state.loja;
      let subtotal = this.props.rdOrder.subtotal;
      let total = this.state.total_pedido; //this.props.location.total//this.state.total_pedido;
      let taxa = this.state.taxa;//this.props.location.taxa;
      let pedido = {}



      pedido['loja'] = loja.id_loja;
      pedido['loja_desc'] = loja.descricao;

      pedido['cliente'] = {
        "id_cliente": cli.id_cliente,
        "nome": cli.nome_completo,
        "ddd": cli.ddd1,
        "telefone": cli.telefone1,
        "email": cli.email,
        "cpfNaNota": this.state.cpf
      }



      pedido['endereco'] = {
        "id_endereco": end.id_endereco,
        "logradouro": end.logradouro,
        "numero": end.numero,
        "bairro": end.bairro,
        "cidade": end.cidade,
        "estado": end.estado,
        "cep": end.cep,
        "complemento": end.complemento,
        "longitude": end.longitude,
        "latitude": end.latitude,
        "ponto_referencia": end.ponto_referencia
      }

      const { typeDelivery } = this.state;

      pedido['tipo_pedido'] = typeDelivery;


      if (typeDelivery === 1 || typeDelivery === 3) pedido['delivery'] = 'S'
      else pedido['delivery'] = 'N'

      let dtAgenda = null;

      if (typeDelivery === 3 || typeDelivery === 4) {
        dtAgenda = moment(this.state.horaRetirada).format('YYYY-MM-DD HH:mm:mm');
      }


      pedido["data_agendamento"] = dtAgenda;



      pedido['pagamento'] = {
        "descricao": this.state.pagEscolhido.descricao,
        "valor_pago": troco > 0 ? troco : total.toFixed(2),
      }




      let itens = [];

      initItens.forEach(element => {

        let subitens = [];
        let extras = [];
        let auxProdGratis = {};
        let objMassa, objBorda = {};


        const { borda, massa, produtos, toppings, prodgratis, partescombo } = element.partes;

        if (element.is_pizza === 'S' && element.qt_particiona > 1 || element.is_combo === 'S') {
          if (element.is_pizza === 'S') {
            let qtParts = produtos.length;

            let valMaior = element.valMaiorPizza;
            let qtReal = (1 / qtParts) * element.quantidade;
            if (produtos.length > 0) {
              produtos.forEach(prod => {

                let item = {
                  "id_produto": prod.id_produto,
                  "nome_produto": prod.produto,
                  "codPdv": prod.codigo,
                  "obs": '',
                  "preco": parseFloat(valMaior),
                  "quantidade": qtReal
                }

                subitens.push(item);
              })
            }
          } else {

            if (partescombo.length > 0) {
              partescombo.forEach(prod => {

                let item = {
                  "id_produto": prod.id_produto,
                  "nome_produto": prod.produto,
                  "codPdv": prod.codigo,
                  "obs": '',
                  "preco": parseFloat(prod.preco.toFixed(2)),
                  "quantidade": 1
                }

                subitens.push(item);
              })
            }
          }

        } else {
          if (produtos.length > 0) {
            produtos.forEach(prod => {
              let preco = 0;
              if (prod.preco) {
                preco = parseFloat(prod.preco.toFixed(2))
              } else if (prod.PRECO) {
                preco = parseFloat(prod.PRECO.toFixed(2))
              }
              let item = {
                "id_produto": prod.id_produto,
                "nome_produto": prod.produto,
                "codPdv": prod.codigo,
                "obs": '',
                "preco": preco
              }

              subitens.push(item);
            })
          }
        }



        if (toppings.length > 0) {
          toppings.forEach(top => {
            let item = {
              "id_produto": top.id_produto,
              "nome_produto": top.produto,
              "codePdv": top.codigo,
              "obs": '',
              "preco": parseFloat(top.preco.toFixed(2))
            }

            extras.push(item);
          })
        }

        if (massa) {
          objMassa = {
            "id_massa": massa.id_massa,
            "massa": massa.descricao,
            "codePdv": massa.CodPdv,
            "preco": massa.preco
          }
        }

        if (prodgratis) {
          auxProdGratis = {
            "id_produto": prodgratis.id_produto,
            "nome_produto": prodgratis.produto,
            "codePdv": prodgratis.codigo,
            "obs": '',
            "preco": 0,
            "quantidade": 1
          }
        }

        if (borda) {
          objBorda = {
            "id_borda": borda.id_borda,
            "borda": borda.descricao,
            "codePdv": borda.CodPdv,
            "preco": borda.preco
          }
        }


        let auxPreco = 0;


        if (element.preco) {
          auxPreco = element.preco
        } else if (element.PRECO) {
          auxPreco = element.PRECO
        }
        if (element.preco) auxPreco = element.preco
        let item = {
          "id_produto": element.id_produto,
          "nome_produto": element.produto,
          "codePdv": element.codigo,
          "preco": element.is_pizza === 'S' && element.qt_particiona > 1 ? 0 : parseFloat(Number(auxPreco).toFixed(2)),
          "subtotal": element.subtotal,
          "total": element.total,
          "combo": element.is_combo,
          "pizza": element.is_pizza,
          "quantidade": element.quantidade,
          "subitens": subitens,// depois
          "extras": extras, // depois
          "obs": element.obs ? element.obs : '',
          "promocao": false,
          "massa": objMassa,
          "borda": objBorda,
          "prodGratis": auxProdGratis
        }

        itens.push(item);
      });

      pedido['itens'] = itens;

      pedido['subtotal'] = parseFloat(subtotal.toFixed(2));
      pedido['taxa'] = parseFloat(taxa.toFixed(2));
      pedido['total_pedido'] = parseFloat(total.toFixed(2));
      pedido['troco'] = parseFloat((parseFloat(troco) - parseFloat(total)).toFixed(2));
      let geral_obs = this.state.obsPag;
      pedido['obs_geral'] = geral_obs.replace("'", "");


      let response = await services.enviaPedido(pedido, token);

      if (response) {
        this.setState({ numeroPedido: response.data.code_lanc, confirmaPedido: true });
        this.props.setItens([]);
      }

      this.setState({ loadingPage: false });
    } catch (error) {
      this.setState({ loadingPage: false })
    }
  }

  handleAcceptPromo = () => {

    this.setState({ goEditarItens: true });

  }

  handlePromo = () => {
    // if(services.askPromo()) return
    // this.setState({displayBanner : 'block',topBanner : 'block'}, ()=>services.setAskPromo(true));        
    return;
  }

  handleNotAcceptPromo = () => {
    this.setState({ displayBanner: 'none' });
  }

  tooggleLoading = () => {
    this.setState({ loadingPage: !this.state.loadingPage });
  }

  handleCpfNota = (e) => {
    let user = services.getUser();

    if (this.state.cpfNaNota === "nao") {
      this.setState({ cpfNaNota: e.target.value, cpf: user.dados_cli.cpf });
    }
    else {
      this.setState({ cpfNaNota: e.target.value, cpf: "" });
    }
  }

  handleCpfText = (e) => {
    this.setState({ cpf: e.target.value.replace(/[^0-9]/g, '') })
  }


  validaAgendamentos = () => {

    const now = moment();
    let currentStore = {};

    if (!isArray(this.props.rdStores.stores)) {
      currentStore = this.props.rdStores.stores;
    } else {
      currentStore = this.props.rdStores.stores[0];
    }



    const choiced = moment(this.state.horaRetirada);
    if (now.isAfter(choiced)) {
      alert('Data inferior a atual');
      return false;
    }

    const weekDay = choiced.day();
    const index = currentStore.expedientes.findIndex(e => e.diaDaSemana === weekDay);

    if (index !== -1) {
      const expediente = currentStore.expedientes[index];

      let aux = expediente.hrAbertura.split(":");
      const hI = moment(choiced).set({ hour: aux[0], minute: aux[1] });


      aux = expediente.hrFechamento.split(":");
      const hF = moment(choiced).set({ hour: aux[0], minute: aux[1] });


      if (!choiced.isBetween(hI, hF)) {
        alert('A loja não estará aberta na data escolhida.')
        return false
      }
    }

    return true;
  }


  handleHoraRetirada = (e) => {
    this.setState({ horaRetirada: e.target.value });
  }



  verifyAdress = async (item, type) => {

    let auxStores = [];

    if (!isArray(this.props.rdStores.stores)) {
      auxStores.push(this.props.rdStores.stores)
    } else {
      auxStores = this.props.rdStores.stores;
    }

    const stores = await services.returnNextStore(auxStores, item.cep);
    const currentStore = stores[0];

    if (stores.length > 0) {
      const index = stores.findIndex(s => currentStore.id_loja === s.id_loja);
      if (index !== -1) {
        let _taxa = stores[index].TAXA;

        if (type && (type === 2 || type === 4)) _taxa = 0;

        this.setState({ showAdressChoice: false, taxa: _taxa, v_pedido: this.state.total_pedido + stores[index].TAXA })
        this.props.setAdressToDelivery(item);
        return true;
      }
    }

    return false

  }



  handleVerifyFromAdress = async (adress) => {
    if (!await this.verifyAdress(adress)) {
      alert('Infelizmente essa loja não atende à esse endereço :(')
    }
  }




  choiceTypeDelivery = async (type) => {
    let isVerifiedAdress = false;
    let adressToPut = {};
    //tis.props.rdUser.adress[0]

    if (this.props.rdUser.adress.length > 1) {
      let isV = false;
      for (let i = 0; i < this.props.rdUser.adress.length; i++) {
        isV = await this.verifyAdress(this.props.rdUser.adress[i], type);
        if (isV) {
          isVerifiedAdress = true;
          adressToPut = this.props.rdUser.adress[i];
          break;
        }
      }

    } else {
      adressToPut = this.props.rdUser.adress[0];
      isVerifiedAdress = await this.verifyAdress(adressToPut, type);
    }


    if (type === 1 || type === 2) {
      if (!await services.verficaLojaAberta(this.state.loja.id_loja)) {
        return alert('A loja está fechada no momento');
      }
    }




    if (type === 4 && this.state.taxa > 0) {
      this.setState({
        total_pedido: this.state.total_pedido - this.state.taxa,
        taxa: 0
      })
    }



    let showAdressChoice = type === 1;


    if (this.props.rdUser.adress.length === 1) {
      if (isVerifiedAdress) {
        this.props.setAdressToDelivery(adressToPut);
      }
      showAdressChoice = false;
    }

    if (!isVerifiedAdress && (type !== 4 && type !== 2)) return alert('Infelizmente essa loja não atende à esse endereço :(');

    this.setState({ typeDelivery: type, showAdressChoice }, () => {
      if (type === 2) {
        this.setState({ taxa: 0 })
        this.openModal({});
      }
    });
  }






  handleDate = (date) => {
    this.setState({ dtChoiced: date })
  }







  render() {
    if (this.state.goEditarItens) {
      return <Redirect to={{ pathname: "LancaPedido", dados_loja: this.state.loja, logado: true, state: { from: this.props.location } }} />
    }

    if (this.props.rdOrder.logado) {

      return (
        <div>
          <BannerPromo
            handleAcceptPromo={this.handleAcceptPromo}
            handleNotAcceptPromo={this.handleNotAcceptPromo}
            display={this.state.displayBanner}
          />
          {
            this.state.loadingPage ? (
              <Loading />
            ) : ''
          }

          {
            this.state.confirmaPedido ? (
              <ConfirmaPedido numeropedido={this.state.numeroPedido} />
            ) : ''
          }

          <Header logado={true} where="lancamento" />

          <div className="container-pagamento">
            <div className="container">
              <div className="col-md-8 col-sm-12 col-xs-12 semBordas">

                <ContainerTypes>
                  <CardType color={this.state.typeDelivery === 1} onClick={() => this.choiceTypeDelivery(1)}>
                    <LabelType color={this.state.typeDelivery === 1}>Quero que me entregue</LabelType>
                  </CardType>

                  <CardType color={this.state.typeDelivery === 2} onClick={() => this.choiceTypeDelivery(2)}>
                    <LabelType color={this.state.typeDelivery === 2}>Vou retirar</LabelType>
                  </CardType>

                  {this.state.entregaAgendada && <CardType color={this.state.typeDelivery === 3} onClick={() => this.choiceTypeDelivery(3)}>
                    <LabelType color={this.state.typeDelivery === 3}>Entrega agendada</LabelType>
                  </CardType>}

                  {this.state.retiradaAgendada && <CardType color={this.state.typeDelivery === 4} onClick={() => this.choiceTypeDelivery(4)}>
                    <LabelType color={this.state.typeDelivery === 4}>Retirada Agendada</LabelType>
                  </CardType>}
                </ContainerTypes>


                {this.state.typeDelivery === 1 && <div className="listPagamentos">

                  {this.props.rdOrder.adress.numero && <div className="cardAdress" onClick={() => this.setState({ showAdressChoice: true })}>
                    <h2>Endereço para entrega</h2>
                    <p>{this.props.rdOrder.adress.logradouro}, {this.props.rdOrder.adress.numero}, {this.props.rdOrder.adress.cidade} - {this.props.rdOrder.adress.estado} - {this.props.rdOrder.adress.cep}</p>
                  </div>}

                  <h2 style={{ color: '#000' }}><span><FontAwesomeIcon icon={faShoppingBag} className="faShoppingBag" /></span>Selecione a Forma de Pagamento</h2>
                  {
                    this.state.arrPags.map(item => {
                      return (
                        <div className="linePags" onClick={this.openModal.bind(this, item)}>
                          {item.descricao}
                        </div>
                      );
                    })
                  }
                </div>}

                {(this.state.typeDelivery === 3 || this.state.typeDelivery === 4) && <>
                  <ContainerAgendamento>

                    <FcClock size={60} />

                    <p style={{ marginLeft: 20, padding: 0, margin: 0, fontSize: 14 }}>
                      {this.state.typeDelivery === 3 ? 'Nos informe data e hora da entrega' :
                        'Nos informe data e hora da retirada'
                      }
                    </p>


                    <form noValidate>
                      <TextField
                        onChange={this.handleHoraRetirada}
                        type="datetime-local"
                        defaultValue="2017-05-24T10:30"
                        value={this.state.horaRetirada}

                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </form>

                    {(this.state.typeDelivery === 3 || this.state.typeDelivery === 4) && this.state.horaRetirada && <>
                      <Button onClick={() => this.openModal({ retiradaAgendada: true })} id={"btnEnviarAgenda"}>Continuar</Button>
                    </>}

                  </ContainerAgendamento>
                </>
                }

              </div>


              <div className="col-md-4 col-sm-12 col-xs-12 text-center" style={{ marginBottom: 20 }}>
                <ItensPedido isPag={this.state.taxa > 0} total={this.state.total_pedido} taxa={this.state.taxa} subtotal={this.props.rdOrder.subtotal} showPag={false} />
              </div>

            </div>
          </div>




          <Modal show={this.state.showModalPagamentos} onHide={this.closeModal} dialogClassName="customModal">
            <Modal.Body className="customBodyModal modalPag" >
              <div className="listPagamentos">
                <h2 style={{ color: '#000' }}><span><FontAwesomeIcon icon={faShoppingBag} className="faShoppingBag" /></span>Selecione a Forma de Pagamento</h2>
                {
                  this.state.arrPags.map(item => {
                    return (
                      <div className="linePags" onClick={this.openModal.bind(this, item)}>
                        {item.descricao}
                      </div>
                    );
                  })
                }
              </div>
            </Modal.Body>
          </Modal>




          <Modal show={this.state.showAdressChoice} onHide={this.closeModal} dialogClassName="customModal">
            <span onClick={() => this.setState({ showAdressChoice: false })}><MdClose className="closeModalAdress" /></span>
            <Modal.Body className="customBodyModal modalPag" >
              <div className="listPagamentos">
                <h2 style={{ color: '#000', display: 'flex' }}><span><BsFillHouseFill className="faShoppingBag" /></span>Selecione o endereço de entrega</h2>
                {
                  this.props.rdUser.adress.map(item => {
                    return (
                      <div className="linePags" onClick={() => this.handleVerifyFromAdress(item)}>
                        {item.descricao}
                        <p id="adressInfo">{item.logradouro}, {item.numero}</p>
                      </div>
                    );
                  })
                }
              </div>
            </Modal.Body>
          </Modal>



          <Modal show={this.state.showPagamento} onHide={this.closeModal} dialogClassName="customModal">
            <Modal.Body className="customBodyModal modalPag" >
              <div className="row">
                <div className="col-md-12">
                  <p>Tipo de Pagamento Escolhido : <span style={{ fontWeight: 'bold' }}>{this.state.pagEscolhido.descricao}</span></p>
                  <p>Total do Pedido : R$ <span style={{ fontWeight: 'bold' }}>{this.state.total_pedido.toFixed(2)}</span></p>

                  <div className="cpfNanotaContent">
                    <p>CPF/CNPJ na nota ?</p>
                    <div className="contentRadioCpf">
                      <label className="radio-inline"><input type="radio" name="cpf na nota sim" value="sim"
                        checked={this.state.cpfNaNota === "sim"} onChange={this.handleCpfNota} />Sim</label>

                      <label className="radio-inline"><input type="radio" name="cpf na nota nao" value="nao"
                        checked={this.state.cpfNaNota === "nao"} onChange={this.handleCpfNota} />Não</label>
                    </div>
                  </div>
                  <div>
                    <input maxLength="14" type="text" id="edtCpfNota" placeholder="CPF/CNPJ" value={this.state.cpf} onChange={this.handleCpfText}
                      style={{ display: this.state.cpfNaNota === "sim" ? "block" : "none", transition: 'all .7s' }}
                    />
                  </div>



                  {
                    this.state.pagEscolhido.solicita_troco ? (
                      <div className="cpfNanotaContent">
                        <p>Precisa de troco ?</p>
                        <label className="radio-inline"><input type="radio" name="sim" value="sim"
                          checked={this.state.selectOption === 'sim'} onChange={this.handleRadio} />Sim</label>

                        <label className="radio-inline"><input type="radio" name="nao" value="nao"
                          checked={this.state.selectOption === 'nao'} onChange={this.handleRadio} />Não</label>
                      </div>

                    ) : ''
                  }

                  <input type="text" id="edtTroco" placeholder="Troco para" value={this.state.troco} onChange={this.handleTroco}
                    style={{ display: this.state.selectOption === 'sim' ? "block" : "none", transition: 'all .7s' }}
                  />
                  <p><input type="text" id="obsPag" maxlength="100" placeholder="Alguma observação? Digite aqui" value={this.state.obsPag} onChange={this.handleObsPag} /></p>

                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="customFooterModal">
              <button type="button" className="btn btn-success btn-enviarPedido" onClick={this.enviaPedido}>Enviar Pedido</button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    } else {
      return <Redirect to={{ pathname: "/", state: this.props.location }} />
    }
  }

}


const mapStateToProps = state => ({
  rdUser: state.user,
  rdOrder: state.order,
  rdStores: state.stores
})

const mapDispathToPros = dispatch => bindActionCreators(Actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispathToPros)(Pagamento))